var _path, _g, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsdc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17162_78967)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_17162_78967",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 72,
    height: 72
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.00012207H72V72H0V0.00012207Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_17162_78967)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 0.00012207C55.8826 0.00012207 72 16.1175 72 36.0001C72 55.8811 55.8826 72.0001 36 72.0001C16.1174 72.0001 0 55.8811 0 36.0001C0 16.1175 16.1174 0.00012207 36 0.00012207Z",
    fill: "#2775CA"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2508 61.0298C29.2508 61.8766 28.5876 62.3577 27.7686 62.102C16.884 58.6297 8.99219 48.4233 8.99219 36.3804C8.99219 24.338 16.884 14.1312 27.7686 10.6588C28.5876 10.4048 29.2508 10.8843 29.2508 11.7311V13.8215C29.2508 14.3853 28.8139 15.0488 28.2767 15.2325C19.665 18.3948 13.4959 26.6678 13.4959 36.3661C13.4959 46.0644 19.665 54.3391 28.2767 57.4998C28.8139 57.6978 29.2508 58.3466 29.2508 58.9123V61.0298Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.245 53.2507C38.245 53.8725 37.7369 54.3806 37.1159 54.3806H34.8708C34.2498 54.3806 33.7417 53.8725 33.7417 53.2507V49.6937C28.8285 49.0305 26.4292 46.2769 25.7796 42.5362C25.6662 41.9001 26.1743 41.3216 26.824 41.3216H29.3935C29.9298 41.3216 30.3818 41.7033 30.4947 42.2388C30.975 44.4696 32.2596 46.1779 36.1979 46.1779C39.1061 46.1779 41.1679 44.5543 41.1679 42.1271C41.1679 39.6979 39.9533 38.7808 35.6898 38.0742C29.3935 37.2274 26.4149 35.3211 26.4149 30.3801C26.4149 26.5686 29.2953 23.6043 33.756 22.9686V19.4815C33.756 18.8601 34.2645 18.3516 34.8851 18.3516H37.1302C37.7512 18.3516 38.2593 18.8601 38.2593 19.4815V23.0676C41.8875 23.718 44.1886 25.7778 44.9373 29.1941C45.078 29.8446 44.5699 30.4504 43.9068 30.4504H41.5345C41.0264 30.4504 40.603 30.1113 40.4479 29.6175C39.8126 27.4444 38.2593 26.5129 35.5626 26.5129C32.584 26.5129 31.045 27.9525 31.045 29.971C31.045 32.1027 31.9208 33.175 36.4953 33.8397C42.6779 34.6866 45.8692 36.451 45.8692 41.718C45.8692 45.7128 42.9041 48.9458 38.2593 49.6937V53.2507H38.245Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2302 62.1022C43.412 62.3578 42.748 61.8768 42.748 61.0299V58.9411C42.748 58.3197 43.1293 57.7412 43.7221 57.5285C52.3339 54.3662 58.503 46.0932 58.503 36.3949C58.503 26.6966 52.3339 18.4235 43.7221 15.2613C43.1858 15.0633 42.748 14.4144 42.748 13.8487V11.7599C42.748 10.913 43.412 10.4193 44.2302 10.686C55.1149 14.1604 63.0066 24.3668 63.0066 36.4092C62.9931 48.423 55.1149 58.6155 44.2302 62.1022Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17162_78967"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdc);
export default __webpack_public_path__ + "static/media/usdc.1e7c969d2a33d9311321770e74d9a09d.svg";
export { ForwardRef as ReactComponent };